<template>
  <Index
  />
</template>
<script route="/refund_offline/refund_offline_apply">
import Index from './refund_offline_apply.jsx'

export default {
  components: {Index}
}
</script>
<style scoped>

</style>